import { useCallback, useState } from "react";
import AccountMpProvider from "@/core/data-provider/data-mp/account/account-mp-provider";
import useErrorTranslation from "@/core/helpers/useErrorTranslation";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";

export default function useCreateCharacter() {
  const tError = useErrorTranslation();
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState<string>("");
  const [isCompleted, setIsCompleted] = useState<null | boolean>(null);

  const createCharacterHandler = useCallback(async () => {
    try {
      setIsPending(true);
      setError("");

      const response = await AccountMpProvider.createCharacter();

      if (response instanceof RpcMpProviderSuccessResponse) {
        setIsCompleted(true);
      } else {
        setError(tError(response.message));
        setIsCompleted(false);
      }
    } catch ({ message }) {
      setError(tError(message));
      setIsCompleted(false);
    } finally {
      setIsPending(false);
    }
  }, []);

  return {
    createCharacterHandler,
    isPending,
    isCompleted,
    error,
  };
}
